(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rc-pdp-tracking"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.RetroChromaPdpTracking) return;

  const regionSelectors = Object.freeze({
    product_description: 'p, ul, ol',
    product_details: '.product-specifications__table > .product-specifications__row',
    recommendations_upper: '.product-series-recs__card img',
    beyond_the_first_look: 'article img',
    customer_snapshots: 'img',
    brand_story: 'p',
    recommendations_lower: '.resource-list__item img',
  });
  const accordionNames = new Set(['shipping_returns', 'recommendations_upper']);
  let state = null;
  let active = false;
  let interval = null;
  let mutationObserver = null;
  let privacyLoading = false;
  let privacyRetryAfter = 0;
  let targets = [];
  let lastAllowed = false;
  const pending = new Map();
  const intents = new Map();

  function permission() {
    try {
      return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
    } catch {
      return false;
    }
  }

  function loadPrivacy() {
    if (window.Shopify?.customerPrivacy || privacyLoading || performance.now() < privacyRetryAfter) return;
    if (typeof window.Shopify?.loadFeatures !== 'function') return;
    privacyLoading = true;
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        privacyLoading = false;
        privacyRetryAfter = performance.now() + (error ? 5000 : 0);
        if (active && !error) sample();
      });
    } catch {
      privacyLoading = false;
      privacyRetryAfter = performance.now() + 5000;
    }
  }

  function send(event, sectionName) {
    if (!active || !state || document.visibilityState !== 'visible' || !permission()) return false;
    if (event === 'pdp_section_view' && !Object.hasOwn(regionSelectors, sectionName)) return false;
    if (event === 'accordion_open' && !accordionNames.has(sectionName)) return false;
    if (event !== 'pdp_section_view' && event !== 'accordion_open') return false;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, product_id: state.productId, section_name: sectionName });
    return true;
  }

  function visibleRatio(element) {
    if (!element?.isConnected || !element.getClientRects().length) return 0;
    if (element.tagName === 'IMG' && (!element.complete || !element.naturalWidth)) return 0;
    const rect = element.getBoundingClientRect();
    const width = Math.min(rect.width, 240);
    const height = Math.min(rect.height, 64);
    if (width <= 0 || height <= 0) return 0;
    const area = width * height;
    let left = Math.max(0, rect.left);
    let right = Math.min(window.innerWidth, rect.left + width);
    let top = Math.max(0, rect.top);
    let bottom = Math.min(window.innerHeight, rect.top + height);
    if (right <= left || bottom <= top) return 0;

    for (let node = element; node instanceof Element; node = node.parentElement) {
      if (node.hidden || (node.tagName === 'DETAILS' && !node.open)) return 0;
      const style = getComputedStyle(node);
      if (style.display === 'none' || style.visibility !== 'visible' || Number(style.opacity) === 0) return 0;
      if (node !== element) {
        const box = node.getBoundingClientRect();
        if (/(hidden|clip|scroll|auto)/.test(style.overflowX)) {
          left = Math.max(left, box.left + node.clientLeft);
          right = Math.min(right, box.left + node.clientLeft + node.clientWidth);
        }
        if (/(hidden|clip|scroll|auto)/.test(style.overflowY)) {
          top = Math.max(top, box.top + node.clientTop);
          bottom = Math.min(bottom, box.top + node.clientTop + node.clientHeight);
        }
      }
    }
    return Math.max(0, right - left) * Math.max(0, bottom - top) / area;
  }

  function syncConfig() {
    const config = document.querySelector('#MainContent [data-rc-pdp-config]');
    const productId = config?.dataset.productId;
    if (!/^\d+$/.test(productId || '')) {
      if (state) {
        state = null;
        pending.clear();
        intents.clear();
      }
      return false;
    }
    if (!state || state.productId !== productId || state.path !== location.pathname) {
      state = { productId, path: location.pathname, sections: new Set(), accordions: new Set() };
      pending.clear();
      intents.clear();
    }
    return true;
  }

  function scan() {
    if (!active) return;
    syncConfig();
    targets = [];
    document.querySelectorAll('#MainContent [data-pdp-region]').forEach((region) => {
      const name = region.dataset.pdpRegion;
      if (!Object.hasOwn(regionSelectors, name)) return;
      const candidates = Array.from(region.querySelectorAll(regionSelectors[name]));
      const isRecommendation = name === 'recommendations_upper' || name === 'recommendations_lower';
      for (const element of isRecommendation ? candidates : candidates.slice(0, 1)) {
        targets.push({ name, element });
      }
    });
    sample();
  }

  function sample() {
    if (!active || !syncConfig()) return;
    loadPrivacy();
    const allowed = permission();
    if (allowed !== lastAllowed) {
      pending.clear();
      intents.clear();
      lastAllowed = allowed;
    }
    if (!allowed || document.visibilityState !== 'visible') {
      pending.clear();
      intents.clear();
      return;
    }
    const now = performance.now();
    const visible = new Map();
    for (const { name, element } of targets) {
      if (!state.sections.has(name) && visibleRatio(element) >= 0.5) {
        const previous = pending.get(name);
        if (!visible.has(name) || previous?.element === element) visible.set(name, element);
      }
    }
    for (const name of pending.keys()) if (!visible.has(name)) pending.delete(name);
    for (const [name, element] of visible) {
      let record = pending.get(name);
      if (!record || record.element !== element) {
        record = { element, since: now };
        pending.set(name, record);
      }
      if (now - record.since >= 1000 && send('pdp_section_view', name)) {
        state.sections.add(name);
        pending.delete(name);
      }
    }
    for (const [details, intent] of intents) {
      if (!details.isConnected || now - intent.time > 1200) intents.delete(details);
    }
  }

  function onClick(event) {
    if (!event.isTrusted || event.button !== 0 || !active || !syncConfig()) return;
    const summary = event.target instanceof Element ? event.target.closest('summary') : null;
    const details = summary?.parentElement;
    const name = details?.dataset.pdpAccordion;
    if (!details?.matches('#MainContent details[data-pdp-accordion]') || !accordionNames.has(name)) return;
    intents.delete(details);
    if (details.open || !permission() || document.visibilityState !== 'visible') return;
    const intent = { time: performance.now(), name, event };
    intents.set(details, intent);
    setTimeout(() => onToggle({ target: details }), 0);
  }

  function onToggle(event) {
    const details = event.target;
    const intent = intents.get(details);
    if (!details.open) {
      intents.delete(details);
      sample();
      return;
    }
    if (!intent) return;
    intents.delete(details);
    if (intent.event.defaultPrevented || performance.now() - intent.time > 1200) return;
    if (!state?.accordions.has(intent.name) && send('accordion_open', intent.name)) state.accordions.add(intent.name);
    sample();
  }

  function onConsent() {
    pending.clear();
    intents.clear();
    lastAllowed = permission();
    sample();
  }

  function start() {
    if (active) return;
    active = true;
    state = null;
    lastAllowed = false;
    document.addEventListener('click', onClick, true);
    document.addEventListener('toggle', onToggle, true);
    document.addEventListener('scroll', sample, true);
    document.addEventListener('visibilitychange', sample);
    document.addEventListener('visitorConsentCollected', onConsent);
    window.addEventListener('resize', sample);
    window.addEventListener('popstate', scan);
    mutationObserver = new MutationObserver(scan);
    mutationObserver.observe(document.body, {
      subtree: true, childList: true, attributes: true,
      attributeFilter: ['open', 'hidden', 'class', 'style', 'data-product-id', 'data-pdp-region'],
    });
    interval = setInterval(sample, 100);
    scan();
  }

  function stop() {
    active = false;
    clearInterval(interval);
    mutationObserver?.disconnect();
    document.removeEventListener('click', onClick, true);
    document.removeEventListener('toggle', onToggle, true);
    document.removeEventListener('scroll', sample, true);
    document.removeEventListener('visibilitychange', sample);
    document.removeEventListener('visitorConsentCollected', onConsent);
    window.removeEventListener('resize', sample);
    window.removeEventListener('popstate', scan);
    pending.clear();
    intents.clear();
    targets = [];
    state = null;
  }

  window.RetroChromaPdpTracking = Object.freeze({
    version: '1.0.0-group-a',
    get status() {
      return { active, analyticsAllowed: permission(), productId: state?.productId || null,
        sections: [...(state?.sections || [])], accordions: [...(state?.accordions || [])],
        pending: [...pending.keys()], targetCount: targets.length };
    },
  });
  window.addEventListener('pagehide', stop);
  window.addEventListener('pageshow', start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

})();
